/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NavbarQueryVariables = {};
export type NavbarQueryResponse = {
    readonly me: {
        readonly " $fragmentRefs": FragmentRefs<"LeftSide_data" | "RightSide_data">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"RightSide_announcementData" | "RightSide_communication_data" | "Announcement_data" | "LeftSide_menuData" | "RightSide_menuIcon_data">;
};
export type NavbarQuery = {
    readonly response: NavbarQueryResponse;
    readonly variables: NavbarQueryVariables;
};



/*
query NavbarQuery {
  ...RightSide_announcementData
  ...RightSide_communication_data
  ...Announcement_data
  ...LeftSide_menuData
  ...RightSide_menuIcon_data
  me {
    ...LeftSide_data
    ...RightSide_data
  }
}

fragment Announcement_data on Query {
  announcements(where: {includeAcknowledged: false, disabled: false}) {
    edges {
      node {
        title
        content
        id
        type
        displayType
      }
    }
  }
}

fragment AnnouncementsBell_data on Query {
  announcementsBellData: announcements(where: {includeAcknowledged: true, disabled: false}) {
    edges {
      node {
        title
        content
        id
        type
        displayType
      }
    }
  }
}

fragment LeftSide_data on UserProfile {
  company {
    customisation {
      companyLogo: displayCompanyLogo
    }
    id
  }
  privileges {
    menus {
      nodeName
    }
  }
}

fragment LeftSide_menuData on Query {
  currentUser {
    menuItems {
      admin {
        alignment
        icon
        id
        isDisplay
        isExternal
        label
        url
      }
      claim {
        alignment
        icon
        id
        isDisplay
        isExternal
        label
        url
      }
      config {
        alignment
        icon
        id
        isDisplay
        isExternal
        label
        url
      }
      dashboard {
        alignment
        icon
        id
        isDisplay
        isExternal
        label
        url
      }
      outstandingCommunication {
        alignment
        icon
        id
        isDisplay
        isExternal
        label
        url
      }
      reporting {
        alignment
        icon
        id
        isDisplay
        isExternal
        label
        url
      }
      scoreboard {
        alignment
        icon
        id
        isDisplay
        isExternal
        label
        url
      }
      video {
        alignment
        icon
        id
        isDisplay
        isExternal
        label
        url
      }
      bookingService {
        alignment
        icon
        id
        isDisplay
        isExternal
        label
        url
      }
      specialist {
        alignment
        icon
        id
        isDisplay
        isExternal
        label
        url
      }
    }
    id
  }
}

fragment RightSide_announcementData on Query {
  ...AnnouncementsBell_data
  currentUser {
    menuItems {
      announcementsNotification {
        icon
        isDisplay
        id
      }
    }
    id
  }
}

fragment RightSide_communication_data on Query {
  communications: claimCommuications(first: 2, where: {boxes: Inbox, acknowledged: false}) {
    totalCount
    edges {
      node {
        claimId
        claimRef
        message
        id
      }
    }
  }
}

fragment RightSide_data on UserProfile {
  company {
    customisation {
      applicationLogo
    }
    id
  }
  privileges {
    menus {
      nodeName
    }
  }
}

fragment RightSide_menuIcon_data on Query {
  ...SystemMenuPropsData
}

fragment SystemMenuPropsData on Query {
  currentUser {
    menuItems {
      config {
        icon
        id
      }
    }
    name
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AnnouncementEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Announcement",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDisplay",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "alignment",
    "storageKey": null
  },
  (v2/*: any*/),
  (v0/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isExternal",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NavbarQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LeftSide_data"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RightSide_data"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "RightSide_announcementData"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "RightSide_communication_data"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Announcement_data"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "LeftSide_menuData"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "RightSide_menuIcon_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NavbarQuery",
    "selections": [
      {
        "alias": "announcementsBellData",
        "args": [
          {
            "kind": "Literal",
            "name": "where",
            "value": {
              "disabled": false,
              "includeAcknowledged": true
            }
          }
        ],
        "concreteType": "AnnouncementConnection",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "announcements(where:{\"disabled\":false,\"includeAcknowledged\":true})"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticatedUser",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MenuView",
            "kind": "LinkedField",
            "name": "menuItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "announcementsNotification",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "admin",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "claim",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "dashboard",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "outstandingCommunication",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "reporting",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "scoreboard",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "video",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "bookingService",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MenuItem",
                "kind": "LinkedField",
                "name": "specialist",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "communications",
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 2
          },
          {
            "kind": "Literal",
            "name": "where",
            "value": {
              "acknowledged": false,
              "boxes": "Inbox"
            }
          }
        ],
        "concreteType": "ClaimCommunicationConnection",
        "kind": "LinkedField",
        "name": "claimCommuications",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClaimCommunicationEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClaimCommunication",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "claimId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "claimRef",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "claimCommuications(first:2,where:{\"acknowledged\":false,\"boxes\":\"Inbox\"})"
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "where",
            "value": {
              "disabled": false,
              "includeAcknowledged": false
            }
          }
        ],
        "concreteType": "AnnouncementConnection",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "announcements(where:{\"disabled\":false,\"includeAcknowledged\":false})"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanyProfile",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyCustomisation",
                "kind": "LinkedField",
                "name": "customisation",
                "plural": false,
                "selections": [
                  {
                    "alias": "companyLogo",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayCompanyLogo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationLogo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserPrivileges",
            "kind": "LinkedField",
            "name": "privileges",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PrivilegeMenu",
                "kind": "LinkedField",
                "name": "menus",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b21ba099496adc3d6dfb7189e58bc8b4",
    "id": null,
    "metadata": {},
    "name": "NavbarQuery",
    "operationKind": "query",
    "text": "query NavbarQuery {\n  ...RightSide_announcementData\n  ...RightSide_communication_data\n  ...Announcement_data\n  ...LeftSide_menuData\n  ...RightSide_menuIcon_data\n  me {\n    ...LeftSide_data\n    ...RightSide_data\n  }\n}\n\nfragment Announcement_data on Query {\n  announcements(where: {includeAcknowledged: false, disabled: false}) {\n    edges {\n      node {\n        title\n        content\n        id\n        type\n        displayType\n      }\n    }\n  }\n}\n\nfragment AnnouncementsBell_data on Query {\n  announcementsBellData: announcements(where: {includeAcknowledged: true, disabled: false}) {\n    edges {\n      node {\n        title\n        content\n        id\n        type\n        displayType\n      }\n    }\n  }\n}\n\nfragment LeftSide_data on UserProfile {\n  company {\n    customisation {\n      companyLogo: displayCompanyLogo\n    }\n    id\n  }\n  privileges {\n    menus {\n      nodeName\n    }\n  }\n}\n\nfragment LeftSide_menuData on Query {\n  currentUser {\n    menuItems {\n      admin {\n        alignment\n        icon\n        id\n        isDisplay\n        isExternal\n        label\n        url\n      }\n      claim {\n        alignment\n        icon\n        id\n        isDisplay\n        isExternal\n        label\n        url\n      }\n      config {\n        alignment\n        icon\n        id\n        isDisplay\n        isExternal\n        label\n        url\n      }\n      dashboard {\n        alignment\n        icon\n        id\n        isDisplay\n        isExternal\n        label\n        url\n      }\n      outstandingCommunication {\n        alignment\n        icon\n        id\n        isDisplay\n        isExternal\n        label\n        url\n      }\n      reporting {\n        alignment\n        icon\n        id\n        isDisplay\n        isExternal\n        label\n        url\n      }\n      scoreboard {\n        alignment\n        icon\n        id\n        isDisplay\n        isExternal\n        label\n        url\n      }\n      video {\n        alignment\n        icon\n        id\n        isDisplay\n        isExternal\n        label\n        url\n      }\n      bookingService {\n        alignment\n        icon\n        id\n        isDisplay\n        isExternal\n        label\n        url\n      }\n      specialist {\n        alignment\n        icon\n        id\n        isDisplay\n        isExternal\n        label\n        url\n      }\n    }\n    id\n  }\n}\n\nfragment RightSide_announcementData on Query {\n  ...AnnouncementsBell_data\n  currentUser {\n    menuItems {\n      announcementsNotification {\n        icon\n        isDisplay\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment RightSide_communication_data on Query {\n  communications: claimCommuications(first: 2, where: {boxes: Inbox, acknowledged: false}) {\n    totalCount\n    edges {\n      node {\n        claimId\n        claimRef\n        message\n        id\n      }\n    }\n  }\n}\n\nfragment RightSide_data on UserProfile {\n  company {\n    customisation {\n      applicationLogo\n    }\n    id\n  }\n  privileges {\n    menus {\n      nodeName\n    }\n  }\n}\n\nfragment RightSide_menuIcon_data on Query {\n  ...SystemMenuPropsData\n}\n\nfragment SystemMenuPropsData on Query {\n  currentUser {\n    menuItems {\n      config {\n        icon\n        id\n      }\n    }\n    name\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '446b89ea0691d607554a19dfc5d49127';
export default node;
